module.exports = __webpack_public_path__ + "img/seq1.ac564423.png";